import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'

import { listRegion } from '../../datas/DatasActions'
import { updateProvider, retrieveProvider} from '../ProviderActions'
import FormStepOne from '../components/FormStepOne'
import { asyncValidateUpdateUsername  } from '../../utils/forms/validators'
import { parseValueProvider } from '../../utils/parse'

import { addNotifSuccess, addNotifError } from '../../notification/NotificationActions'


const mapStateToProps = (state) => {
    return {
  		regions : state.datas.regions,
        user : state.user,
        provider : state.provider.provider,
        initialValues: state.provider.provider.provider
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        listRegion: () => {
            return dispatch(listRegion())
        }
    }
};


const config = {
    form: 'FormStepOneForm',
    onSubmit: (values, dispatch, props) => {
        window.scrollTo(0, 0);

       const fields = ["first_name", "last_name", "username", "password", "phone", "region"];
       return dispatch(updateProvider(props.provider.provider.id, parseValueProvider(fields, values)))
        .then((response) => {
            
            if(props.create){
                props.nextPage()
            }else{
                dispatch(addNotifSuccess("Vos informations sont enregistrées", "Confirmation"))
            }
            
        })
        .catch((error) => {
            dispatch(addNotifError("Erreur", "Veuillez recommencer."))
        })
    },
    asyncValidate: asyncValidateUpdateUsername,
    asyncBlurFields: ['username', 'phone'],
};

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm(config)(FormStepOne))



// WEBPACK FOOTER //
// ./src/provider/containers/FormStepOneContainer.js